<template>
  <div class="row">
    <form class="col s12">
      <div class="row">
        <div class="input-field col s6">
          <i class="material-icons prefix">search</i>
          <textarea id="icon_prefix2" class="materialize-textarea"></textarea>
          <label for="icon_prefix2">Pesquisar</label>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
    export default {
        name: "CaixaPesquisa"
    }
</script>



// WEBPACK FOOTER //
// src/components/Widgets/Pesquisa/CaixaPesquisa.vue